// extracted by mini-css-extract-plugin
export default {"template6":"styles_template6__pb4Kx"};